import Vue from 'vue';
import BaseFeatureToggle from '@base/components/BaseFeatureToggle.vue';

Vue.component('FeatureToggle', BaseFeatureToggle);

export default BaseFeatureToggle;
